var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4C2.89543 2 2 2.89543 2 4C2 4.55228 2.44772 5 3 5H21C21.5523 5 22 4.55228 22 4C22 2.89543 21.1046 2 20 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19H20C20.5523 19 21 18.5523 21 18V6.5H3V18C3 18.5523 3.44772 19 4 19H11.25V20.4144L7.8181 21.2724C7.41625 21.3729 7.17193 21.7801 7.27239 22.1819C7.37285 22.5837 7.78006 22.8281 8.1819 22.7276L12 21.7731L15.8181 22.7276C16.2199 22.8281 16.6271 22.5837 16.7276 22.1819C16.8281 21.7801 16.5837 21.3729 16.1819 21.2724L12.75 20.4144V19ZM13.6854 13.6538C13.4525 13.8172 13.2857 14.0818 13.2857 14.3804C13.2857 14.591 13.1267 14.7618 12.9305 14.7618H11.0695C10.8733 14.7618 10.7143 14.591 10.7143 14.3804C10.7143 14.0818 10.5475 13.8172 10.3146 13.6538C9.52113 13.0971 9 12.1583 9 11.0939C9 9.38521 10.3431 8 12 8C13.6569 8 15 9.38521 15 11.0939C15 12.1583 14.4789 13.0971 13.6854 13.6538ZM11.3002 15.5287H12.6998C13.0782 15.5287 13.3849 15.8581 13.3849 16.2644C13.3849 16.6706 13.0782 17 12.6998 17H11.3002C10.9218 17 10.6151 16.6706 10.6151 16.2644C10.6151 15.8581 10.9218 15.5287 11.3002 15.5287Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPresentation);
export default __webpack_public_path__ + "static/media/idea-presentation.65403917118454451492176fcc3f8c04.svg";
export { ForwardRef as ReactComponent };